export class CompanyModel {
    companyUid: string;
    businessType: any;
    internalSlotId: string;
    currencyIsocode: string;
    name: string;
    countryIso2code: string;
    eetThumbprint: string;
    eetActive: boolean;
    eetValidFrom: Date;
    eetValidTo: Date;
    eetPassword?: any;
    companyName: string;
    street: string;
    houseNumber: string;
    city: string;
    zipCode: string;
    companyLin: string;
    companyTin: string;
    line1Top: string;
    line2Top: string;
    line3Top: string;
    line4Top: string;
    line5Top: string;
    line1Bottom: string;
    line2Bottom: string;
    line3Bottom: string;
    line4Bottom?: any;
    line5Bottom: string;
    active: boolean;
    tnTrains: any[];
    tsVats: any[];

    languageISOCode: string;

    // New non-model items
    newImage: any;

    newCert: any;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/company-list/company.model.ts